export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#FE5C2D',
    contrastText: '#FFF',
    light: '#FE5C2D1a',
  },
  secondary: {
    main: '#FCF0EC99',
    contrastText: '#082232',
  },
  text: {
    primary: '#08456B',
    secondary: '#64748B',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFF7F0',
    paper: '#FFF',
    default: '#FFF',
    footer: '#082232',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#DDDDDD',
    tableSubhead: '#FFF7F0',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
  },
  verticalBar: {
    used: '#7BD6D0',
    unused: '#7BD6D01a',
    unlimited: '#C0C0C0',
  }
};
